import { PropsWithChildren } from 'react'

type BadgeContainerProps = {
  title: string
}

export function BadgeContainer({
  children,
  title,
}: PropsWithChildren<BadgeContainerProps>) {
  return (
    <>
      <h4 className='text-sm font-medium lg:text-base text-[#093269]'>
        {title}:
      </h4>
      <div className='flex gap-2 pt-2 flex-wrap'>{children}</div>
    </>
  )
}
